import ReactDOM from "react-dom";
import React from "react";
import AppQr from "../qr_react_src/AppQr";

document.addEventListener("DOMContentLoaded", () => {
    const mountPoint = document.getElementById("react-qr")
    const appVersion = parseInt(mountPoint.dataset.version)

    ReactDOM.render(
        <AppQr version={appVersion}/>,
        mountPoint
    )
})